import isEqual from 'lodash/isEqual';

/**
 * Given two objects and a list of fields, check if they values at those fields are different
 * between the two objects.
 *
 * if all fields are equal return false (no change)
 * otherwise return true (change exists)
 *
 * primary use case is componentDidUpdate hooks where we check a subset of props
 *
 * @param a
 * @param b
 * @param fields
 * @param comparator - optional param for an equality function
 */
export default function checkFields(a, b, fields, comparator = isEqual) {
  for (const field of fields) {
    if (!comparator(a[field], b[field])) return true;
  }
  return false;
}
